<template>
  <div class="index-con">
    <!-- 左侧：侧边栏占满全高 -->
    <aside :class="showclass" class="lyadmin-side">
      <leftnav></leftnav>
    </aside>
    <!-- 右侧：header + 内容区 -->
    <div class="right-area">
      <header class="index-header lyadmin-header">
        <navcon></navcon>
      </header>
      <main class="index-main" v-if="isMultiTabs">
        <mutitabs></mutitabs>
      </main>
      <main class="index-main" v-else>
        <keep-alive>
          <router-view v-if="$route.meta.isActive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.isActive"></router-view>
      </main>
    </div>
  </div>
</template>
<script setup>
    import {ref, onMounted,getCurrentInstance,computed} from 'vue'
    import navcon from '../components/navcon.vue'
    import leftnav from '../components/leftnav.vue'
    import Mutitabs from "../components/mutitabs";
    import {useMutitabsStore} from "@/store/mutitabs";
    import {useSiteThemeStore} from "@/store/siteTheme";
    import {useBillDataStore} from "@/store/billData";

    let bus = getCurrentInstance().appContext.config.globalProperties.$Bus; // 声明$Bus
    let showclass = ref("asideshow")
    let showtype = ref(false)
    const mutitabsStore =  useMutitabsStore()
    let isMultiTabs = mutitabsStore.isMultiTabs

    const siteThemeStore = useSiteThemeStore()

    const asideshowWidth = computed(()=>{
        return siteThemeStore.menuWidth +'px'
    })

    onMounted(()=>{
        bus.on('toggle', value => {
            if (value) {
                showclass.value = 'asideshow'
            } else {
                setTimeout(() => {
                    showclass.value = 'aside'
              }, 300)
            }
        })
        
        // 登录后预加载账单数据
        const billDataStore = useBillDataStore()
        billDataStore.loadData()
    })
</script>
<style scoped>
  .index-con {
    display: flex;
    height: 100vh;
    width: 100%;
    overflow: hidden;
  }

  /* 侧边栏：占满全高 */
  .lyadmin-side {
    flex-shrink: 0;
    height: 100vh;
    background: #16202d;
    border-right: 1px solid #1e2d3e;
    transition: width 0.25s ease;
    overflow: hidden;
  }

  .aside {
    width: 64px;
  }

  .asideshow {
    width: v-bind(asideshowWidth);
  }

  /* 右侧区域：header + 内容 */
  .right-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: 100vh;
    overflow: hidden;
  }

  .index-header {
    padding: 0;
    width: 100%;
    height: 56px;
    min-height: 56px;
    background: #FFFFFF;
    border-bottom: 1px solid #E5E5EA;
    box-shadow: none;
    flex-shrink: 0;
  }

  .index-main {
    flex: 1;
    overflow: auto;
    padding: 24px;
    background: #f0f2f5;
    display: flex;
    flex-direction: column;
  }

  /* 让 router-view 渲染的组件撑满 index-main */
  .index-main > * {
    flex: 1;
    min-height: 0;
  }
</style>

<!-- 不带 scoped：确保各层级子组件都能正确撑满 flex 容器 -->
<style>
  /* mutitabs 根元素：撑满 index-main 并建立 flex 列布局 */
  .index-main > .myeltas1 {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* el-tabs header：固定高度不拉伸 */
  .myeltas1 > .el-tabs {
    flex-shrink: 0;
  }

  /* 隐藏 mutitabs 的 tab 头部（页签导航栏） */
  .myeltas1 > .el-tabs {
    display: none !important;
  }

  /* mutitabs 内 router-view 渲染的页面根元素：撑满剩余空间 */
  .myeltas1 > div:not(.el-tabs):not(.lymain-maximize-exit) {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }
</style>